<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Meldebox</h1>

    <div class="bg-gray-300 p-8 mb-4">
      <p class="mb-3 text-lg">{{ findCategory(report.category_id) }}</p>
      <p>Status: {{ findStatus(report.status_id) }}</p>
      <div v-if="report.anonym">
        ANONYM
      </div>
      <div v-if="!report.anonym">
        {{ report.vorname }} {{ report.nachname }} ({{ report.email }})
      </div>
    </div>

    <div v-for="r in reportitems" :key="r.id" class="p-8 mb-4" :class="r.user_id > 0 ? 'bg-green-300' : 'bg-gray-300'">
      <p class="mb-3 text-lg border-b border-gray-600">{{ r.title }}</p>
      <pre>{{ r.description }}</pre>
      <div v-if="r.file_path" class="my-12">
        <a :href="'/storage/' + r.file_path.replace('public/', '')" download class="btn-indigo text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">DATEIANHANG</a>
      </div>
      <div v-if="r.user_id > 0" class="mt-8 text-right">{{ findUser(r.user_id) }}</div>
      <div v-if="r.user_id == 0" class="mt-8 text-right">
        <span v-if="report.anonym">
          ANONYM
        </span>
        <span v-if="!report.anonym">
          {{ report.vorname }} {{ report.nachname }} ({{ report.email }})
        </span>
      </div>
    </div>

    <div class="bg-gray-300 p-8 mb-4">
      <form @submit.prevent="store">
        <div class="mt-8">
          <select-input v-model="form.status_id" :error="form.errors.status_id" class="pb-8 pr-6 w-full" label="Status">
            <option v-for="s in status" :key="s.id" :value="s.id">{{ s.text }}</option>
          </select-input>
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full" label="Titel" />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Deine Beschreibung/Meldung" />
        </div>

        <div class="mt-16 flex">
          <loading-button class="btn-indigo" type="submit">Speichern</loading-button>
        </div>
      </form>
    </div>


  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    FileInput,
  },
  layout: Layout,
  props: {
    report: Object,
    reportitems: Array,
    status: Array,
    categories: Array,
    users: Array,
    hashId: String,
  },
  data() {
    return {
      step: 1,
      form: this.$inertia.form({
        category_id: 1,
        status_id: this.report.status_id,
        title: '',
        name: '',
        description: '',
        file: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.put(`/backend/report/${this.hashId}`)
    },
    findCategory(category_id) {
      console.log('HASH', this.hashId)
      console.log(this.categories)
      const cat = (this.categories.find(c => {
        if(c.id == category_id)
          return c
      }))

      return cat.text
    },
    findStatus(status_id) {
      console.log(status_id)
      console.log(this.status)
      const st = (this.status.find(s => {
        if(s.id == status_id)
          return s
      }))

      return st.text
    },

    findUser(user_id) {
      console.log(this.users)
      const user = (this.users.find(u => {
        if(u.id == user_id)
          return u
      }))

      return user.first_name + ' ' + user.last_name
    },
  },
}
</script>
